import { COUNTRY_USA } from 'utils/constants';
/* eslint-disable */
import 'vendor/canada-post/js/addresscomplete-2.00.min.js';
import 'vendor/canada-post/css/addresscomplete-2.00.min.css';

const MAP_LEGACY_COUNTRY_NAME_TO_NEW_NAME = {
  'Sint Maarten (Dutch)': 'Sint Maartin (Dutch Part), SX',
  'Bonaire, Sint Eustatius and Saba': 'Dutch Caribbean',
  Turkey: 'Türkiye',
};

export const setupCanadaPost = (formController) => {
  const canadaPostControl = new pca.Address(
    [
      {
        element: 'address1',
        mode: pca.fieldMode.SEARCH,
      },
    ],
    {
      key: process.env.REACT_APP_CANADA_POST_KEY,
      autoSearch: false,
      bar: {
        showLogo: false,
        logoLink: false,
      },
    }
  );

  canadaPostControl.listen('load', function () {
    canadaPostControl.setCountry(COUNTRY_USA);
  });

  canadaPostControl.listen('populate', (foundAddress) => {
    formController.reset({
      ...formController.getValues(),
      address1: foundAddress.Line1,
      address2: foundAddress.Line2,
      zipcode: foundAddress.PostalCode,
      state: foundAddress.Province,
      city: foundAddress.City,
      country:
        MAP_LEGACY_COUNTRY_NAME_TO_NEW_NAME[foundAddress.CountryName] || foundAddress.CountryName,
    });
  });

  canadaPostControl.load();
};
